import React from 'react';

const TreatmentItem = ({ icon, title }) => {
  return (
    <div className="flex items-center space-x-4 mb-4">
      <div className="text-gray-400">
        {icon}
      </div>
      <span className="text-gray-200">{title}</span>
    </div>
  );
};

const PricingCard = ({ title, price, treatments }) => {
  return (
    <div className="bg-primary/90 p-8 rounded-lg text-white">
      <div className="flex justify-between items-center mb-8">
        <h3 className="text-2xl font-bold font-heading">{title}</h3>
        <span className="text-4xl font-bold">£{price}</span>
      </div>
      <div>
        {treatments.map((treatment, index) => (
          <TreatmentItem 
            key={index}
            icon={treatment.icon}
            title={treatment.title}
          />
        ))}
      </div>
    </div>
  );
};

const Pricing = () => {
  const toothIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
    </svg>
  );

  const coreTreatments = [
    { icon: toothIcon, title: "Prescription (excluding medication)" },
    { icon: toothIcon, title: "Re-cementing a Crown/Bridge" },
    { icon: toothIcon, title: "Easing of dentures" },
    { icon: toothIcon, title: "Semi-permanent filling" }
  ];

  const advancedTreatments = [
    { icon: toothIcon, title: "Draining of an abscess" },
    { icon: toothIcon, title: "Initial root canal treatment" },
    { icon: toothIcon, title: "Extraction (excluding surgical extraction)" },
    { icon: toothIcon, title: "Management of an infected socket/ wisdom tooth" }
  ];

  return (
    <div className="py-16 bg-primary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-4">
            Treatment Fees (per item)
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            We won't recommend treatments you don't need, for the sake of making money. If we can fix the issue quickly and cheaply and that's the right thing for you, then we're happy to help!
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <PricingCard 
            title="Core Treatment"
            price="49"
            treatments={coreTreatments}
          />
          <PricingCard 
            title="Advanced Treatment"
            price="149"
            treatments={advancedTreatments}
          />
        </div>
      </div>
    </div>
  );
};

export default Pricing;
